import { PRODUCTS } from "../../../data/products";

// Domain product -> UI card props
export const toProductCardProps = (p) => {
    const images =
        Array.isArray(p.images) && p.images.length
            ? p.images
            : p.imageSrc
                ? [p.imageSrc]
                : [];

    return {
        id: p.id,
        name: (p.name || "").toUpperCase(),
        description: (p.description || "").toUpperCase(),
        imageSrc: p.imageSrc,
        imageAlt: p.imageAlt || p.name || "",
        images,
        backgroundColor: p.backgroundColor || "#E9ECEF",
        backgroundDesign: p.backgroundDesign,
        claims: p.claims || [],
        price: p.price || "$0.00",
        productLinkUrl: p.productLinkUrl,
        productSellingDescription: (p.productSellingDescription || "").toUpperCase(),
        product: p,
    };
};

// Keep the same order as the ids array
export const selectProductsByIds = (ids = []) =>
    ids
        .map((id) => PRODUCTS.find((p) => p.id === id))
        .filter(Boolean);

export const selectProductCardPropsByIds = (ids = []) =>
    selectProductsByIds(ids).map(toProductCardProps);
